import styled from 'styled-components';

export const Menu = styled.div`
	margin-left: 28px;
	margin-right: 24px;
	padding-top: 23px;
	position: relative;
	z-index: 2;

	> .bg-img-wrapper {
		position: absolute;
		z-index: -1000;
		top: -6px;
		bottom: -9px;
		left: -7px;
		right: -7px;

		> .bg-img {
			position: absolute;
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
		}
	}
`;

export const Container = styled.div`
	max-width: ${props => (props.is1200 ? '1200px' : '1400px')};
	margin: auto;
	position: relative;
`;

export const TopWrapper = styled.div`
	display: flex;
`;


export const Search = styled.div`
	position: absolute;

	width: 534px;
	height: 46px;
	/* margin-left: 237px; */
	left: 0;
	right: 0;
	margin-left: auto;
	margin-right: auto;
	transform: translateX(-35px);
`;

export const Cart = styled.div`
	position: absolute;
	right: -42px;
	top: 50%;
	transform: translateX(100%) translateY(-50%);
`;

export const Nav = styled.div``;

export const MerchantImg = styled.img`
	width: 163px;
	height: 88px;
	box-shadow: 0px 1px 19px 2px rgba(0, 0, 0, 0.1);
	position: absolute;
	top: 35px;
	/* right: 242px; */
	right: 0;
	cursor: pointer;
`;

export const Category = styled.div``;
